module.exports = __webpack_public_path__ + "images/800x800_Individual_0000s_0010_Suso_Forest-Fruits_1.png";